
export function v4() {
	const cryptoValues = () => (crypto.getRandomValues(new Uint8Array(1))[0]);
	// tslint:disable-next-line:no-bitwise
	const random = (c: number) => (c ^ cryptoValues() & 15 >> c / 4);
	return [1e7, 1e3, 4e3, 8e3, 1e11].join('-').replace(/[018]/g, x => random(Number(x)).toString(16));
}

export default {
	v4
}